import loginBg from "./images/login-bg.jpg";
import addTaskImg from "./images/add-task.jpg";
import alertSleepImg from "./images/alert-sleep.jpg";
import checkEmailImg from "./images/check-email.jpg";
import diamondImg from "./images/diamond.jpg";
import lockedDisplayImg from "./images/locked-display.jpg";
import webPageImg from "./images/web-page.jpg";
import lockedDocument from "./images/locked-document.jpg";
import addAppointmentImg from "./images/add-appointment.jpg";
import rejectImg from "./images/reject.jpg";

export const images = {
  loginBg,
  lockedDocument,
  addTask: addTaskImg,
  alertSleep: alertSleepImg,
  checkEmail: checkEmailImg,
  diamond: diamondImg,
  lockedDisplay: lockedDisplayImg,
  webPage: webPageImg,
  addAppointment: addAppointmentImg,
  reject: rejectImg,
};

export default images;
